import React, { Component } from 'react';
import Link from 'gatsby-link'

const activeLink = 'home'

class Navigation extends Component {

  render() {

    return (
      <nav style={{
        background: '#FF1654',
      }} className="navbar navbar-expand-lg navbar-dark">
        <Link className="navbar-brand" to="/">Michael Brooks' Blog</Link>
        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
  
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav mr-auto">
            <li className="nav-item">
              <Link className={ `nav-link` } to="/">Home <span className="sr-only">(current)</span></Link>
            </li>
            <li className="nav-item">
              <Link activeClassName="active" className="nav-link" to="/blog">Blog</Link>
            </li>
            <li className="nav-item">
              <Link activeClassName="active" className="nav-link" to="/categories">Categories</Link>
            </li>
          </ul>
        </div>
      </nav>
    )
  }
}

export default Navigation


// WEBPACK FOOTER //
// ./src/components/Navigation.js